import { render, staticRenderFns } from "./CreateSnowflakeAccountDialog.vue?vue&type=template&id=1ced375c&"
import script from "./CreateSnowflakeAccountDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateSnowflakeAccountDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports